var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CScrollbar',{staticClass:"navigation navigation-main h-100",attrs:{"id":"main-menu-navigation","data-menu":"menu-navigation","settings":_vm.psSettings,"tag":"ul"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }